import {
  Box,
  Button,
  Checkbox,
  Divider,
  Grid,
  TextField,
  Container,
  Autocomplete,
  Typography,
  InputAdornment,
  Snackbar,
  Alert,
  AlertTitle,
  FormGroup,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ClearIcon from "@mui/icons-material/Clear";
import {
  createHXRule,
  getAirlineDetails,
  getCustomer,
  getCustomerByID,
  getHXRuleByID,
  updateHXRule,
} from "../redux/actions/AdminAction";
import { useNavigate, useParams } from "react-router-dom";
import { GET_HX_RULE_RESET } from "../Constants/Constants";
import { TimePicker } from "@mui/x-date-pickers";
import { parse, format, isValid } from "date-fns";

export default function HXCancellationRule() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [rule_name, setRule_name] = useState("");
  const [snackOpen, setSnackOpen] = useState(false);
  const [customerId, setCustomerId] = useState();
  const [PCCs, setPCCs] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [selectAllAirlines, setSelectAllAirlines] = useState(false);
  const [airline_code, setAirline_code] = useState([]);
  const [selectPickCategory, setSelectPickCategory] = useState(false);
  const [selectPickTicket, setSelectPickTicket] = useState(false);
  const [selectSendEmail, setSelectSendEmail] = useState(true);
  const [ticket_status, setTicket_status] = useState([]);
  const [succesQueueNumber, setSuccessQueueNumber] = useState(null);
  const [failQueueNumber, setFailQueueNumber] = useState(null);
  const [run_time, setRun_time] = useState("");
  const [errorAlert, setErrorAlert] = useState(false);

  const HXCancellationGetAirlineDetails = useSelector(
    (state) => state.HXCancellationGetAirlineDetails
  );
  const { airlineInfo } = HXCancellationGetAirlineDetails;

  const GetHXRuleByID = useSelector((state) => state.GetHXRuleByID);
  const { ruleInfo } = GetHXRuleByID;

  const GetCustomers = useSelector((state) => state.GetCustomers);
  const { customersInfo } = GetCustomers;

  const GetCustomerByID = useSelector((state) => state.GetCustomerByID);
  const { customerById } = GetCustomerByID;

  const HXCancellationCreateHXRule = useSelector(
    (state) => state.HXCancellationCreateHXRule
  );
  const { hxRuleInfo, error } = HXCancellationCreateHXRule;

  const UpdateHXRule = useSelector((state) => state.UpdateHXRule);
  const { success, message, updateerror } = UpdateHXRule;

  const token = JSON.parse(localStorage.getItem("userInfo"));

  // useEffect(() => {
  //   setSelectAllAirlines(false);
  // }, [ruleInfo]);

  useEffect(() => {
    dispatch({ type: GET_HX_RULE_RESET });
  }, []);

  useEffect(() => {
    if (!token) {
      navigate("/");
    } else {
      setSelectAllAirlines(false);
      dispatch(getAirlineDetails());
      dispatch(getCustomer());
    }
  }, [dispatch, navigate, token]);

  useEffect(() => {
    setSelectAllAirlines(false);
    if (id === "new") {
      setRule_name("");
      setIsActive(false);
      setPCCs("");
      setAirline_code([]);
      setSelectAllAirlines(false);
      setSelectPickCategory(false);
      setSelectSendEmail(true);
      setSuccessQueueNumber(null);
      setFailQueueNumber(null);
      setRun_time("");
      setCustomerId();
      dispatch({ type: GET_HX_RULE_RESET });
    } else {
      dispatch(getHXRuleByID(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (ruleInfo && Object.keys(ruleInfo).length > 0) {
      setRule_name(ruleInfo.rule_name || "");
      setIsActive(ruleInfo.active || false);
      setPCCs(ruleInfo.pccs || "");
      ruleInfo.airlines &&
        setAirline_code(
          ruleInfo.airlines
            .trim()
            .split(",")
            .map((airline) => airline?.trim())
        );
      ruleInfo.airlines && !ruleInfo.airlines?.trim()
        ? setSelectAllAirlines(true)
        : setSelectAllAirlines(false);
      setSelectPickCategory(ruleInfo.pick_from_category || false);
      setSelectSendEmail(ruleInfo.is_email_enabled || false);
      setTicket_status(ruleInfo?.ticketed_status?.trim().split(" "));
      ruleInfo?.ticketed_status?.trim()
        ? setSelectPickTicket(true)
        : setSelectPickTicket(false);
      setSuccessQueueNumber(ruleInfo.success_queue || null);
      setFailQueueNumber(ruleInfo.fail_queue || null);
      setRun_time(ruleInfo.run_time?.trim() || "");
      setCustomerId(ruleInfo.customer_id);
    }
  }, [ruleInfo]);

  useEffect(() => {
    if (customerById) {
      setPCCs(customerById.pccs);
      console.log(customerById.pccs);
      setCustomerId(customerById.customer_id);
    }
  }, [customerById]);

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
    setErrorAlert(false);
  };

  const handleAirlineCodeChange = (event, newValue) => {
    console.log("NEW Value", newValue);
    const [selectedValue] = newValue.map((option) =>
      option?.airline_code?.trim()
    );
    if (!airline_code?.includes(selectedValue)) {
      setAirline_code((prevState) => [...prevState, selectedValue]);
    }
  };

  const handleSuccessQueueNumber = (event, value) => {
    setSuccessQueueNumber(parseInt(value));
  };

  const handleFailQueueNumber = (event, value) => {
    setFailQueueNumber(parseInt(value));
  };

  const handleIsActive = (event) => {
    setIsActive(event.target.checked);
  };

  const handleSelectAllAirlines = (event) => {
    setSelectAllAirlines(event.target.checked);
    setAirline_code([]);
  };

  const handleSelectPickCategory = (event) => {
    const value = event.target.value === "true";
    setSelectPickCategory(value);
  };

  const handleSelectPickTicket = (event) => {
    const value = event.target.value === "true";
    setSelectPickTicket(value);
    if (!value) {
      setTicket_status([]);
    }
  };

  const handleSelectSendEmail = (event) => {
    const value = event.target.value === "true";
    setSelectSendEmail(value);
  };

  const handleTicketStatus = (event) => {
    const value = event.target.value;
    setTicket_status((prevState) =>
      Array.isArray(prevState)
        ? event.target.checked
          ? [...prevState, value]
          : prevState.filter((v) => v !== value)
        : [value]
    );
  };

  const handlePCCs = (event) => {
    const enteredValues = event.target.value
      .split("\n")
      .map((value) => value?.trim());
    const pccs = enteredValues.join(" ");
    setPCCs(pccs);
  };

  const handleRunTime = (newValue) => {
    if (newValue && isValid(newValue)) {
      const selectedTime = format(newValue, "HHmm");
      setRun_time((prevRunTime) => {
        if (!prevRunTime) {
          return selectedTime;
        } else if (prevRunTime.includes(selectedTime)) {
          return prevRunTime;
        } else {
          return `${prevRunTime} ${selectedTime}`;
        }
      });
    }
  };

  const submitHandler = () => {
    if (
      rule_name &&
      PCCs &&
      (airline_code || selectAllAirlines) &&
      succesQueueNumber &&
      failQueueNumber &&
      run_time &&
      customerId
    ) {
      const hx_rule = {
        rule_name: rule_name?.trim(),
        active: isActive || false,
        pccs: PCCs?.trim(),
        airlines: airline_code?.map((airline) => airline?.trim()).join(","),
        success_queue: succesQueueNumber,
        fail_queue: failQueueNumber,
        run_time: run_time,
        customer_id: customerId,
        pick_from_category: selectPickCategory || false,
        ticketed_status: ticket_status?.join(" ") || null,
        is_email_enabled: selectSendEmail || false,
      };
      if (id === "new") {
        dispatch(createHXRule(hx_rule));
        setSnackOpen(true);

        // Reset all states
        setRule_name("");
        setIsActive(false);
        setPCCs("");
        setAirline_code([]);
        setSuccessQueueNumber();
        setFailQueueNumber();
        setRun_time("");
        setCustomerId();
        setSelectPickCategory(false);

        setTimeout(() => {
          navigate("/hxCancellationRules");
        }, 3000);
      } else {
        dispatch(updateHXRule(id, hx_rule));
        setSnackOpen(true);

        setTimeout(() => {
          navigate("/hxCancellationRules");
        }, 3000);
      }
    } else {
      setSnackOpen(true);
      setErrorAlert(true);
    }
  };

  return (
    <Container sx={{ marginBottom: "5%" }}>
      <Box>
        <Box sx={{ margin: 3, fontSize: 25 }}>
          Manage HX Concellation Rules
          <Divider sx={{ marginTop: 2 }}></Divider>
        </Box>
        <Box sx={{ fontSize: 25, margin: 3 }}>
          {id === "new"
            ? "Add HX Cancellation Rule"
            : "Edit HX Cancellation Rule"}
        </Box>
        <Box sx={{ margin: 3 }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Grid item xs={6}>
                Agency Name
              </Grid>
              <Grid item xs={6} mt={1}>
                <Autocomplete
                  fullWidth
                  options={
                    (customersInfo && Object.values(customersInfo)) || []
                  }
                  onChange={(e, newValue) => {
                    if (newValue) {
                      setRule_name(newValue.customer_name);
                      setCustomerId(newValue.customer_id);
                      console.log("customer_id", customerId);
                      dispatch(getCustomerByID(newValue.customer_id));
                    } else {
                      setRule_name("");
                      setCustomerId();
                    }
                  }}
                  getOptionLabel={(option) =>
                    option?.customer_name?.trim() || ""
                  }
                  value={
                    (customersInfo &&
                      customersInfo.find(
                        (customer) =>
                          customer?.customer_name?.trim() === rule_name?.trim()
                      )) ||
                    null
                  }
                  renderInput={(params) => {
                    return <TextField {...params} variant="outlined" />;
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mt={1}>
              Active?
              <Checkbox checked={isActive} onChange={handleIsActive} />
            </Grid>
            <Grid item xs={12} mt={1}>
              <FormGroup sx={{ flexDirection: "row", alignItems: "center" }}>
                <FormLabel sx={{ color: "black !important" }}>
                  Enable email service:
                </FormLabel>
                <RadioGroup
                  sx={{ marginLeft: 2 }}
                  row
                  defaultValue={selectSendEmail}
                  value={selectSendEmail}
                  onChange={handleSelectSendEmail}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormGroup>
            </Grid>
            <Grid item xs={12} mt={1}>
              <FormGroup sx={{ flexDirection: "row", alignItems: "center" }}>
                <FormLabel sx={{ color: "black !important" }}>
                  Process Ticketed PNR:
                </FormLabel>
                <RadioGroup
                  sx={{ marginLeft: 2 }}
                  row
                  defaultValue={selectPickTicket}
                  value={selectPickTicket}
                  onChange={handleSelectPickTicket}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormGroup>
            </Grid>
            {selectPickTicket && (
              <Grid item xs={12}>
                <FormGroup
                  sx={{ flexDirection: "row", alignItems: "center" }}
                  onChange={handleTicketStatus}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        value="HX"
                        checked={ticket_status?.includes("HX")}
                      />
                    }
                    label="HX"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        value="UN"
                        checked={ticket_status?.includes("UN")}
                      />
                    }
                    label="UN"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        value="UC"
                        checked={ticket_status?.includes("UC")}
                      />
                    }
                    label="UC"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        value="NO"
                        checked={ticket_status?.includes("NO")}
                      />
                    }
                    label="NO"
                  />
                </FormGroup>
              </Grid>
            )}
            <Grid item xs={12}>
              <Grid item xs={6} mt={2}>
                PCCs
              </Grid>
              <Grid item xs={6} mt={1}>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  disabled
                  onChange={handlePCCs}
                  value={PCCs ? PCCs.split(" ").join(" ") : ""}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Grid
                item
                xs={6}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography sx={{ mt: 1 }}>Airlines</Typography>
                <Typography>
                  Select all Airlines
                  <Checkbox
                    checked={selectAllAirlines}
                    onChange={handleSelectAllAirlines}
                  />
                </Typography>
              </Grid>
              <Grid item xs={6} mt={1}>
                <Autocomplete
                  disabled={selectAllAirlines}
                  multiple
                  fullWidth
                  options={airlineInfo || []}
                  getOptionLabel={(option) =>
                    `${option.airline_code} - ${option.airline_name}` || ""
                  }
                  value={airline_code
                    .map(
                      (code) =>
                        airlineInfo?.find((airline) =>
                          airline.airline_code === code
                            ? airline.airline_name
                            : ""
                        ) || ""
                    )
                    .filter(Boolean)}
                  filterOptions={(options, { inputValue }) =>
                    options.filter(
                      (option) =>
                        option.airline_code
                          .toLowerCase()
                          .includes(inputValue.toLowerCase()) ||
                        option.airline_name
                          .toLowerCase()
                          .includes(inputValue.toLowerCase())
                    )
                  }
                  onChange={handleAirlineCodeChange}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                />
                {airline_code?.length > 0 && !selectAllAirlines ? (
                  <Box
                    fullWidth
                    sx={{
                      mt: 2,
                      maxHeight: 200,
                      overflow: "auto",
                      "& .selected-airlines": {
                        width: "100%",
                        padding: "10px",
                        boxSizing: "border-box",
                        border: "1px solid #d4d4d4",
                      },
                      "& .selected-airline-button": {
                        backgroundColor: "#e8e9eb",
                        color: "black",
                        "&:hover": {
                          backgroundColor: "#333333",
                          color: "white",
                        },
                        whiteSpace: "nowrap",
                        margin: "5px",
                      },
                    }}
                  >
                    <Box className="selected-airlines">
                      {airline_code.map((code, index) => {
                        const airline = airlineInfo?.find(
                          (airline) => airline.airline_code.trim() === code
                        );
                        return (
                          <Button
                            key={index}
                            className="selected-airline-button"
                            startIcon={<ClearIcon />}
                            onClick={() => {
                              const updatedAirlines = [...airline_code];
                              updatedAirlines.splice(index, 1);
                              setAirline_code(updatedAirlines);
                            }}
                          >
                            {airline
                              ? `${airline.airline_name.trim()} (${airline.airline_code.trim()})`
                              : ""}
                          </Button>
                        );
                      })}
                    </Box>
                  </Box>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
            <Grid item xs={12} mt={1}>
              <FormGroup sx={{ flexDirection: "row", alignItems: "center" }}>
                <FormLabel sx={{ color: "black !important" }}>
                  Pick PNRs from queue categories?
                </FormLabel>
                <RadioGroup
                  sx={{ marginLeft: 2 }}
                  row
                  defaultValue={selectPickCategory}
                  value={selectPickCategory}
                  onChange={handleSelectPickCategory}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormGroup>
            </Grid>

            <Grid item xs={12} mt={2}>
              <Grid item xs={6}>
                Success Queue
              </Grid>
              <Grid item xs={6} mt={1}>
                <Autocomplete
                  fullWidth
                  options={Array.from({ length: 75 }, (_, index) => index + 26)}
                  onChange={handleSuccessQueueNumber}
                  value={succesQueueNumber}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      value={succesQueueNumber}
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Grid item xs={6}>
                Fail Queue
              </Grid>
              <Grid item xs={6} mt={1}>
                <Autocomplete
                  fullWidth
                  options={Array.from({ length: 75 }, (_, index) => index + 26)}
                  onChange={handleFailQueueNumber}
                  value={failQueueNumber}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Grid item xs={6}>
                Run at timings (between 0000 to 2359 UTC Time)
              </Grid>
              <Grid item xs={6} mt={1}>
                <TimePicker
                  sx={{
                    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
                      {
                        borderColor: "#000000",
                        opacity: 0.2,
                      },
                  }}
                  minutesStep={60}
                  // views={["hours"]}
                  ampm={false}
                  mask="__:__"
                  value={parse(run_time, "HHmm", new Date())}
                  defaultValue={format(new Date(), "HHmm")}
                  onAccept={handleRunTime}
                  TextFieldProps={{ error: false }}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                />
                {run_time && (
                  <Box
                    fullWidth
                    sx={{
                      mt: 2,
                      maxHeight: 200,
                      overflow: "auto",
                      "& .selected-run_time": {
                        width: "100%",
                        padding: "10px",
                        boxSizing: "border-box",
                        border: "1px solid #d4d4d4",
                      },
                      "& .selected-run_time-button": {
                        backgroundColor: "#e8e9eb",
                        color: "black",
                        "&:hover": {
                          backgroundColor: "#333333",
                          color: "white",
                        },
                        whiteSpace: "nowrap",
                        margin: "5px",
                      },
                    }}
                  >
                    <Box className="selected-run_time">
                      {run_time?.split(" ").map((time, index) => (
                        <Button
                          className="selected-run_time-button"
                          startIcon={<ClearIcon />}
                          onClick={() => {
                            const updatedTimes = [...run_time.split(" ")];
                            updatedTimes.splice(index, 1);
                            setRun_time(updatedTimes.join(" "));
                          }}
                          variant="contained"
                          size="small"
                          color="secondary"
                        >
                          {time}
                        </Button>
                      ))}
                    </Box>
                  </Box>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Button
                onClick={submitHandler}
                variant="contained"
                type="submit"
                sx={{ backgroundColor: "#282828" }}
              >
                Save
              </Button>
            </Grid>
          </Grid>
          {hxRuleInfo && (
            <Snackbar
              open={snackOpen}
              autoHideDuration={5000}
              onClose={handleSnackClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{ width: "20%" }}
            >
              <Alert
                onClose={handleSnackClose}
                severity="success"
                sx={{ width: "100%" }}
              >
                <AlertTitle>Success</AlertTitle>
                {hxRuleInfo}
              </Alert>
            </Snackbar>
          )}
          {error && (
            <Snackbar
              open={snackOpen}
              autoHideDuration={5000}
              onClose={handleSnackClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{ width: "20%" }}
            >
              <Alert
                onClose={handleSnackClose}
                severity="error"
                sx={{ width: "100%" }}
              >
                <AlertTitle>Error</AlertTitle>
                {error}
              </Alert>
            </Snackbar>
          )}
          {success && message && (
            <Snackbar
              open={snackOpen}
              autoHideDuration={5000}
              onClose={handleSnackClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{ width: "20%" }}
            >
              <Alert
                onClose={handleSnackClose}
                severity="success"
                sx={{ width: "100%" }}
              >
                <AlertTitle>Success</AlertTitle>
                {message}
              </Alert>
            </Snackbar>
          )}
          {updateerror && (
            <Snackbar
              open={snackOpen}
              autoHideDuration={5000}
              onClose={handleSnackClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{ width: "20%" }}
            >
              <Alert
                onClose={handleSnackClose}
                severity="error"
                sx={{ width: "100%" }}
              >
                <AlertTitle>Error</AlertTitle>
                {updateerror}
              </Alert>
            </Snackbar>
          )}
          {errorAlert && (
            <Snackbar
              open={snackOpen}
              autoHideDuration={5000}
              onClose={handleSnackClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{ width: "20%" }}
            >
              <Alert
                onClose={handleSnackClose}
                severity="error"
                sx={{ width: "100%" }}
              >
                <AlertTitle>Required field error</AlertTitle>
                Please enter all the fields.
              </Alert>
            </Snackbar>
          )}
        </Box>
      </Box>
    </Container>
  );
}
